import React, { useEffect, useState } from "react";
import {
  List as BaseList,
  CreateButton,
  TopToolbar,
  useNotify,
  FilterButton,
  usePermissions,
  Filter,
  useListContext,
  useUpdate,
  useRedirect,
  useDataProvider,
  useGetOne,
  useResourceContext,
} from "react-admin";
import RegexSearchInput from "../../components/RegexSearchInput";
import moment from "moment";
import DownloadCsvButton from "../../components/downloadCsv";
import { ImportButton } from "react-admin-import-csv";
import {
  FormControlLabel,
  Grow,
  Checkbox,
  Box,
  Button,
  TextField,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from "@mui/material";
import ExportButton from "../../components/ExcelExportButton";
import useExport from "../../components/UseExcelExport";
import InfiniteListLayout from "./components/MyInfiniteList";
import UpgradePlanModal from "../../components/UpgradePlanModal";
import AddIcon from "@mui/icons-material/Add";
import UpgradeStickyBanner from "../../utils/UpgradeStickyBanner";
import DescriptionIcon from "@mui/icons-material/Description";
import { initializeWhatsAppInstance, getWhatsAppInstanceStatus } from "../../components/dataProvider";
import { useProvider } from "../../ProviderContext";
const NameFilter = [<RegexSearchInput source="phone" label="Teléfono" />];

const profile = JSON.parse(localStorage.getItem("profile"));

const Filters = (props) => (
  <Filter {...props}>
    {/* Usar RegexSearchInput para nombre y teléfono */}
    <RegexSearchInput source="fullName" label="Buscar por Nombre" alwaysOn disabled={profile?.plan === "freemium"} />
    <RegexSearchInput source="phone" label="Teléfono" disabled={profile?.plan === "freemium"} />
  </Filter>
);

const ListActions = (props) => {
  const dataProvider = useDataProvider();
  const { provider } = useProvider();

  const { getExportData, exportData, setExportData } = useExport("enterprise/customers");
  const [openModal, setOpenModal] = useState(false);
  const [openMessageModal, setOpenMessageModal] = useState(false);

  const slug = JSON.parse(localStorage.getItem("profile")).slugUrl;
  const URL_MESSAGE = `${process.env.REACT_APP_WEB_CLIENT_URL}${slug ? `/${slug}/` : "/"}`;

  const profile = JSON.parse(localStorage.getItem("profile") || "{}");
  const [messageText, setMessageText] = useState(JSON.parse(localStorage.getItem("profile")).message) || "";
  const [includeLink, setIncludeLink] = useState(messageText.includes(URL_MESSAGE));

  const [draftMessageText, setDraftMessageText] = useState(messageText);
  const [draftIncludeLink, setDraftIncludeLink] = useState(includeLink);

  const [openQRModal, setOpenQRModal] = useState(false);
  const [QRCode, setQRCode] = useState(null);
  const [isConnected, setIsConnected] = useState(profile?.isConnected || false);
  const [isCheckingConnection, setIsCheckingConnection] = useState(false);
  const [hasInitialized, setHasInitialized] = useState(false); // Para evitar múltiples llamadas
  const [pollingInterval, setPollingInterval] = useState(null); // Para controlar el interval

  const shouldFetch = !!profile?._id && !isConnected && openQRModal && !hasInitialized;

  useEffect(() => {
    if (profile?.isConnected && profile?.instance_id) setIsConnected(true);
  }, [profile]);

  useEffect(() => {
    if (!shouldFetch) return;

    // Marcar como inicializado para evitar múltiples llamadas
    setHasInitialized(true);

    // Llamar directamente a la nueva API al abrir el modal
    setIsCheckingConnection(true);

    if (profile?._id) {
      initializeWhatsAppInstance(profile._id)
        .then((response) => {
          setIsCheckingConnection(false);

          // Verificar si ya está autenticado
          if (response.data?.data?.isAuthenticated) {
            // Ya está conectado
            setIsConnected(true);
            // No actualizar profile aquí para evitar bucle
          } else if (response.data?.qrImage) {
            // Mostrar QR para escanear
            setQRCode(response.data.qrImage);

            // Iniciar polling para verificar conexión
            const interval = setInterval(() => {
              getWhatsAppInstanceStatus(profile._id)
                .then((statusResponse) => {
                  if (statusResponse.data?.status === "ACTIVE") {
                    setIsConnected(true);
                    // Actualizar localStorage solo cuando realmente se conecte
                    const updatedProfile = { ...profile, isConnected: true };
                    localStorage.setItem("profile", JSON.stringify(updatedProfile));
                    clearInterval(interval);
                    setPollingInterval(null);
                  }
                })
                .catch((error) => {
                  if (!error.message?.includes("Instance not found")) {
                    console.error("❌ Error al verificar estado:", error);
                  }
                });
            }, 5000); // Verificar cada 5 segundos

            // Guardar referencia del interval
            setPollingInterval(interval);
          }
        })
        .catch((error) => {
          setIsCheckingConnection(false);
          console.error("❌ Error al inicializar WhatsApp:", error);
        });
    }
  }, [shouldFetch, profile?._id]); // Quitar 'profile' de las dependencias

  // Cleanup interval on component unmount
  useEffect(() => {
    return () => {
      if (pollingInterval) {
        clearInterval(pollingInterval);
      }
    };
  }, [pollingInterval]);

  const [update, { loading }] = useUpdate();
  const redirect = useRedirect();

  const handleOpenMessageModal = () => {
    setDraftMessageText(messageText);
    setDraftIncludeLink(messageText.includes(URL_MESSAGE));
    setOpenMessageModal(true);
  };

  const handleUpdate = (record) => {
    //console.log("id:", userId);
    setMessageText(draftMessageText);
    setIncludeLink(draftIncludeLink);

    const userId = JSON.parse(localStorage.getItem("profile"))._id;

    update(
      "users",
      {
        id: userId,
        data: {
          message: draftMessageText,
        },
      },
      {
        onSuccess: ({ data }) => {
          const updatedProfile = {
            ...profile,
            message: draftMessageText,
          };

          localStorage.setItem("profile", JSON.stringify(updatedProfile));

          notify("Mensaje guardado.");
        },
        onFailure: (error) => notify(`Error al guardar el mensaje: ${error}`, "warning"),
      }
    );

    setOpenMessageModal(false);
  };

  const { permissions } = usePermissions();
  const { filterValues } = useListContext();

  const handleExportClick = async () => {
    if (!exportData.length) {
      setOpenModal(true);
      await getExportData(filterValues);
      setOpenModal(false);
    }
  };
  const handleClearData = () => {
    setExportData([]);
  };
  const { className, basePath } = props;
  const notify = useNotify();
  const [errors, setErrors] = useState([]);
  const resource = useResourceContext(); // retorna "enterprise/customers", por ejemplo

  const handleClick = () => {
    if (provider?.plan === "freemium") {
      setOpenUpgradeModal(true);
      return;
    }

    redirect(`/${resource}/create`);
  };
  const errorsToString = (errors) => {
    return errors.reduce((acc, error) => {
      return `${acc ? acc + "\n" : ""}${error}`;
    }, "");
  };

  const columns = [
    { label: "Nombre Completo", source: "fullName" },
    { label: "Teléfono", source: "phone" },
    { label: "Email", source: "email" },
    { label: "Fecha de Nacimiento", source: "birthdate", transform: (val) => moment(val).format("DD/MM/YYYY") },
  ];

  const handleOpenLinkWhatsAppModal = () => {
    setOpenQRModal(true);
    // Reset estados cuando se abre el modal
    setQRCode(null);
    setIsCheckingConnection(false);
    setHasInitialized(false); // Resetear para permitir nueva inicialización
  };

  const handleCloseQRModal = () => {
    setOpenQRModal(false);
    // Limpiar el polling cuando se cierre el modal
    if (pollingInterval) {
      clearInterval(pollingInterval);
      setPollingInterval(null);
    }
    if (!pollingInterval && !isConnected) {
      setHasInitialized(false); // Permitir re-inicialización al reabrir
    }
  };

  // Función para regenerar QR manualmente
  const handleGenerateQR = async () => {
    if (!provider?._id) return;

    setIsCheckingConnection(true);
    try {
      const response = await initializeWhatsAppInstance(profile._id);

      setIsCheckingConnection(false);

      // Si ya está autenticado
      if (response.data?.data?.isAuthenticated) {
        setIsConnected(true);
        const updatedProfile = {
          ...profile,
          isConnected: true,
        };
        localStorage.setItem("profile", JSON.stringify(updatedProfile));
      }
      // Si devuelve QR para escanear
      else if (response.data?.qrImage) {
        setQRCode(response.data.qrImage);
      }
    } catch (error) {
      setIsCheckingConnection(false);
      console.error("❌ Error al generar QR:", error);
    }
  };

  const handleRemoveInstace = () => {
    console.log("borrando instance y conne");
    dataProvider
      .update("users/removeInstance", { id: profile._id })
      .then(({ data }) => {
        setIsConnected(false);

        console.log(data);
        const updatedProfile = {
          ...profile,
          instance_id: data?.instance_id || "",
          isConnected: data?.isConnected || false,
        };

        localStorage.setItem("profile", JSON.stringify(updatedProfile));
      })
      .catch((error) => {
        console.error("❌ error al reiniciar la instancia:", error);
      });
  };
  const [openUpgradeModal, setOpenUpgradeModal] = useState(false);
  const handleFilterClick = (event) => {
    if (provider?.plan === "freemium") {
      event.preventDefault(); // evita que se abra el drawer
      setOpenUpgradeModal(true); // abre el modal
      return;
    }
  };
  return (
    <TopToolbar
      className={className}
      style={{
        display: "flex",
        // justifyContent: "space-between",
        alignItems: "center",
        padding: "0 16px",
        marginBottom: "0",
      }}
    >
      {provider?.whatsappLinked && (
        <Button onClick={handleOpenLinkWhatsAppModal} sx={{ fontSize: 10 }}>
          Vincular <br /> WhatsApp
        </Button>
      )}

      {provider?.reminderConfirmed && (
        <Button onClick={handleOpenMessageModal} sx={{ fontSize: 10 }}>
          Mensaje <br /> recordatorio
        </Button>
      )}

      <div style={{ display: "flex", gap: "16px", alignItems: "center" }}>
        <FilterButton filters={NameFilter} onClick={handleFilterClick} />
        {/* <CreateButton basePath={basePath} /> */}
        <Button
          onClick={handleClick}
          startIcon={<AddIcon />}
          sx={{
            color: "#ff770d",
            fontWeight: 500,
            textTransform: "none",
            background: "none",
            boxShadow: "none",
            "&:hover": {
              backgroundColor: "rgba(255, 119, 13, 0.08)",
              boxShadow: "none",
            },
          }}
        >
          CREAR
        </Button>
        <Button
          onClick={() => redirect("/enterprise/customers/forms")}
          startIcon={<DescriptionIcon />}
          sx={{
            color: "#f97316",
            fontWeight: 500,
            textTransform: "none",
            background: "none",
            boxShadow: "none",
            "&:hover": {
              backgroundColor: "rgba(249, 115, 22, 0.08)",
              boxShadow: "none",
            },
          }}
        >
          Ver Plantillas
        </Button>
      </div>
      {permissions !== "admin-sucursal" && (
        <ExportButton
          onClick={() => {
            if (provider?.plan === "freemium") {
              setOpenUpgradeModal(true);
              return;
            }
            handleExportClick();
          }}
          data={exportData}
          columns={columns}
          filename="customers.xlsx"
          clearData={handleClearData}
        />
      )}
      <div style={{ display: "flex", gap: "16px" }}>
        {permissions !== "admin-sucursal" && (
          <ImportButton
            {...props}
            disableImportOverwrite={true}
            transformRows={(csvRows) => {
              return csvRows.map((row) => {
                const transformedRow = {};
                transformedRow.fullName = row.Nombre;
                if (row.Telefono) transformedRow.phone = row.Telefono;
                if (row.Email) transformedRow.email = row.Email;
                transformedRow.addresses = [];
                return transformedRow;
              });
            }}
            validateRow={async (csvRowItem, row) => {
              if (row === 0) {
                setErrors([]);
              }
              if (!csvRowItem.fullName) {
                errors.push(`Fila ${row + 1}: Nombre es requerido`);
                notify(errorsToString(errors), { type: "error", multiLine: true });
                throw new Error("Nombre es requerido");
              }
              if (csvRowItem.phone && isNaN(csvRowItem.phone)) {
                errors.push(`Fila ${row + 1}: Telefono debe ser un numero`);
                notify(errorsToString(errors), { type: "error", multiLine: true });
                throw new Error("Telefono debe ser un numero");
              }
              if (csvRowItem.email && !csvRowItem.email.match(/^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/)) {
                errors.push(`Fila ${row + 1}: Email invalido`);
                notify(errorsToString(errors), { type: "error", multiLine: true });
                throw new Error("Email invalido");
              }
            }}
          />
        )}
        {permissions !== "admin-sucursal" && <DownloadCsvButton />}
      </div>
      <UpgradePlanModal
        open={openUpgradeModal}
        onClose={() => setOpenUpgradeModal(false)}
        planActual={provider?.plan}
        planDestino="standard"
      />
      <Dialog open={openModal} onClose={() => setOpenModal(false)}>
        <DialogContent>
          <Box display="flex" flexDirection="column" alignItems="center">
            <CircularProgress />
            <Typography variant="body1" style={{ marginTop: 16 }}>
              Cargando datos para exportación...
            </Typography>
          </Box>
        </DialogContent>
      </Dialog>

      <Dialog open={openQRModal} onClose={handleCloseQRModal}>
        <DialogContent>
          <DialogTitle> Vincular WhatsApp </DialogTitle>
          <Box display="flex" flexDirection="column" alignItems="center" padding={5} gap={3}>
            {!QRCode && !isConnected && (
              <Box
                sx={{
                  width: 300,
                  height: 300,
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                  border: "1px gray",
                  borderStyle: "dashed",
                  borderRadius: 3,
                  gap: 2,
                  textAlign: "center",
                }}
              >
                {isCheckingConnection ? (
                  // Mostrando loading mientras se verifica la conexión
                  <>
                    <Box
                      sx={{
                        width: 60,
                        height: 60,
                        border: "6px solid #f3f3f3",
                        borderTop: "6px solid #f97316",
                        borderRadius: "50%",
                        animation: "spin 1s linear infinite",
                        "@keyframes spin": {
                          "0%": { transform: "rotate(0deg)" },
                          "100%": { transform: "rotate(360deg)" },
                        },
                      }}
                    />
                    <Box
                      sx={{
                        fontSize: "1rem",
                        color: "#666",
                        fontWeight: 500,
                      }}
                    >
                      Verificando conexión...
                    </Box>
                  </>
                ) : (
                  // Mostrar botón para generar QR
                  <Button onClick={handleGenerateQR} variant="contained" color="primary">
                    Generar QR de WhatsApp
                  </Button>
                )}
              </Box>
            )}

            {QRCode && !isConnected && (
              <Box width={300} p={2} border="1px solid #eee" borderRadius="12px" bgcolor="#f9f9f9" textAlign="center">
                <Typography
                  sx={{
                    fontSize: "0.7rem",
                    color: "#555",
                    marginBottom: 2,
                  }}
                >
                  📲 <b>Escanee el código QR</b> con su aplicación de WhatsApp para iniciar sesión. <br />
                  Luego, asegúrese de que el dispositivo se vincule correctamente y se muestre el <b>
                    ID de instancia
                  </b>{" "}
                  correspondiente para confirmar una conexión exitosa.
                  <br />
                  <b>Importante</b>: Si tras unos minutos <b>no</b> aparece la confirmación intente cerrando la sesión
                  desde su dispositivo <b>(Dispositivos vinculados)</b> y <b>escaneando nuevamente</b>.
                </Typography>

                <img
                  width={300}
                  height={300}
                  src={QRCode}
                  alt="Código QR"
                  style={{ borderRadius: 8, boxShadow: "0 2px 8px rgba(0,0,0,0.1)" }}
                />

                {/* Botón Regenerar QR */}
                <Box mt={2}>
                  <Button onClick={handleGenerateQR} variant="outlined" color="primary" size="small">
                    Regenerar QR
                  </Button>
                </Box>
              </Box>
            )}

            {isConnected && (
              <Box
                sx={{
                  width: 300,
                  height: 300,
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: 2,
                  animation: "fadeInContainer 0.5s ease-out",
                  border: "1px green",
                  borderStyle: "dashed",
                  borderRadius: 3,
                  "@keyframes fadeInContainer": {
                    "0%": { opacity: 0, transform: "scale(0.95)" },
                    "100%": { opacity: 1, transform: "scale(1)" },
                  },
                }}
              >
                <Box
                  sx={{
                    width: 90,
                    height: 90,
                    backgroundColor: "#22c55e",
                    borderRadius: "50%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    fontSize: 48,
                    color: "#fff",
                    boxShadow: "0 4px 15px rgba(34, 197, 94, 0.4)",
                    animation: "popSuccess 0.4s ease-out",
                    "@keyframes popSuccess": {
                      "0%": { transform: "scale(0.6)", opacity: 0 },
                      "80%": { transform: "scale(1.1)", opacity: 1 },
                      "100%": { transform: "scale(1)", opacity: 1 },
                    },
                  }}
                >
                  ✓
                </Box>
                <Typography variant="body2" color="#22c55e" fontWeight="bold">
                  Vinculado correctamente
                </Typography>
              </Box>
            )}

            {isConnected && (
              <Grow in={true} timeout={500}>
                <Box width={300} p={2} border="1px solid #eee" borderRadius="12px" bgcolor="#f9f9f9">
                  <Box display="flex" alignItems="center" mb={1}>
                    <Typography
                      sx={{
                        fontWeight: "bold",
                        color: "#333",
                        fontSize: "0.85rem",
                      }}
                    >
                      ¡WhatsApp conectado!
                    </Typography>
                  </Box>

                  <Typography sx={{ fontSize: "0.75rem", color: "#555", marginBottom: 1 }}>
                    Su cuenta de WhatsApp está vinculada correctamente. Ahora puede enviar mensajes a sus clientes de
                    manera automática y confiable.
                  </Typography>
                </Box>
              </Grow>
            )}

            <Button
              onClick={handleRemoveInstace}
              color="error"
              variant="outlined"
              // sx={{
              //   backgroundColor: "#e53935",
              //   color: "#fff",
              //   '&:hover': {
              //     backgroundColor: "#d32f2f",
              //   },
              // }}
            >
              Desvincular WhatsApp
            </Button>
          </Box>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseQRModal} color="error" variant="contained">
            Cerrar
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog open={openMessageModal} onClose={() => setOpenMessageModal(false)}>
        <DialogTitle>
          <Box display="flex" justifyContent="space-between" alignItems="center">
            <Typography variant="h6">Editar mensaje</Typography>
          </Box>
        </DialogTitle>

        <p style={{ margin: "8px 24px 0", fontSize: "0.875rem", color: "gray" }}>
          * Usa{" "}
          <code>
            <b>{"#nombre"}</b>
          </code>{" "}
          para insertar el nombre del cliente,{" "}
          <code>
            <b>{"#servicio"}</b>
          </code>{" "}
          para incluir el nombre del servicio y{" "}
          <code>
            <b>{"#lapso"}</b>
          </code>{" "}
          para mostrar la cantidad de días que transcurrieron desde el último servicio.
        </p>

        <DialogContent>
          <TextField
            fullWidth
            multiline
            minRows={3}
            value={draftMessageText}
            onChange={(e) => setDraftMessageText(e.target.value)}
            variant="outlined"
            margin="normal"
            label="Mensaje"
          />

          <FormControlLabel
            control={
              <Checkbox
                checked={draftIncludeLink}
                onChange={(e) => {
                  const checked = e.target.checked;
                  setDraftIncludeLink(checked);

                  if (checked && !draftMessageText.includes(URL_MESSAGE)) {
                    setDraftMessageText((prev) => prev.trim() + `\n\n${URL_MESSAGE}`);
                  } else if (!checked) {
                    setDraftMessageText((prev) => prev.replace(`\n${URL_MESSAGE}`, ""));
                  }
                }}
              />
            }
            label="Incluir enlace"
            style={{ marginTop: "8px" }}
          />

          <h5 style={{ fontWeight: "normal", color: "gray" }}>Vista previa:</h5>
          <Box
            mt={2}
            p={2}
            bgcolor="#dcf8c6"
            borderRadius="12px"
            maxWidth="80%"
            alignSelf="flex-start"
            style={{ fontFamily: "Roboto, sans-serif", whiteSpace: "pre-line" }}
          >
            {draftMessageText
              .replaceAll("#nombre", "Juan Pérez")
              .replaceAll("#servicio", "Consulta Médica")
              .replaceAll("#lapso", "25")
              .split("\n")
              .map((line, index) => {
                const isLink = line.startsWith("http://") || line.startsWith("https://");
                return isLink ? (
                  <div key={index}>
                    <a
                      href={line}
                      target="_blank"
                      rel="noopener noreferrer"
                      style={{ color: "#065fd4", textDecoration: "underline" }}
                    >
                      {`\n${line}`}
                    </a>
                  </div>
                ) : (
                  <div key={index}>{line}</div>
                );
              })}
          </Box>
        </DialogContent>
        <DialogActions sx={{ justifyContent: "center" }}>
          <Button onClick={() => setOpenMessageModal(false)} variant="contained" color="error">
            Cancelar
          </Button>
          <Button onClick={handleUpdate} color="success" variant="contained">
            Guardar
          </Button>
        </DialogActions>
      </Dialog>
    </TopToolbar>
  );
};

export const List = (props) => {
  const { permissions } = usePermissions();
  const [totalCount, setTotalCount] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [openUpgradeModal, setOpenUpgradeModal] = useState(false);
  const profile = JSON.parse(localStorage.getItem("profile"));
  const PRIMARY_COLOR = "#FF770D";
  const providerId = profile?.role === "admin-sucursal" ? profile?.employer?._id : profile?._id;
  const { data: provider } = useGetOne("providers", { id: providerId });

  const showFreemiumNotice = provider?.plan === "freemium";
  return (
    <div>
      <BaseList
        pagination={false}
        perPage={20}
        sort={{ field: "birthday", order: "ASC" }}
        actions={<ListActions />}
        filters={<Filters />}
        filter={permissions !== "admin-sucursal" ? null : { providerId: profile.employer._id }}
        empty={provider?.plan === "freemium" ? false : undefined}
        {...props}
      >
        {showFreemiumNotice && (
          <UpgradeStickyBanner
            planActual={provider?.plan}
            planDestino="Standard"
            modulo="Clientes"
            onClickUpgrade={() => setOpenUpgradeModal(true)}
          />
        )}
        <InfiniteListLayout
          setTotalCount={setTotalCount}
          setTotalPages={setTotalPages}
          isRecordatorio={provider?.reminderConfirmed}
          plan={provider?.plan}
        />
      </BaseList>
      <Box display="flex" justifyContent="flex-end" alignItems="center" padding="16px">
        <Typography variant="body1">
          {totalPages} de {totalCount} clientes
        </Typography>
      </Box>
      <UpgradePlanModal
        open={openUpgradeModal}
        onClose={() => setOpenUpgradeModal(false)}
        planActual={provider?.plan}
        planDestino="standard"
      />
    </div>
  );
};
